/* eslint-disable */

import * as clientService from "../services/httpsClient";

export const getCompanies = async (accessToken, params) => {
  try {
    const domain = `originpackage`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getOriginPackage = async (accessToken, params) => {
  const { page, limit, values } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
    reference: values ? values.reference : undefined,
    tracking: values ? values.tracking : undefined,
    package_status: values ? values.package_status : undefined,
    route: values ? values.route : undefined,
    origin: values ? values.origin : undefined,
    destination: values ? values.destination : undefined,
    customer: values ? values.customer : "All",
    package_description: values ? values.package_description : undefined,
    container: values ? values.container : undefined,
    note: values ? values.note : undefined,
    package_type: values ? values.package_type : undefined,
  };

  object.start_date = values?.start_date ? values.start_date : undefined;
  object.end_date = values?.end_date ? values.end_date : undefined;
  try {
    const domain = `originpackage`;
    return await clientService.getApi(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const exportOriginPackage = async (accessToken, params) => {
  try {
    const domain = `originpackage/export-excel-all`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getOriginPackageById = async (accessToken, id, params) => {
  try {
    const domain = `originpackage/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createOriginPackage = async (accessToken, body) => {
  try {
    const domain = `originpackage`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateOriginPackage = async (accessToken, body, id) => {
  try {
    const domain = `originpackage/update/${id}`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteOriginPackage = async (accessToken, body) => {
  try {
    const domain = `originpackage`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteMultiPackageService = async (accessToken, body) => {
  try {
    const domain = `originpackage/delete-all`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getOriginPackageService = async (accessToken, id, body) => {
  try {
    const domain = `originpackageservice/${id}`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createOriginPackageService = async (accessToken, body) => {
  try {
    const domain = `originpackageservice`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateOriginPackageService = async (accessToken, body) => {
  try {
    const domain = `originpackageservice`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteOriginPackageService = async (accessToken, body) => {
  try {
    const domain = `originpackageservice`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getWareHouses = async (accessToken, params) => {
  try {
    const domain = `warehouses/list`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getOriginPackageServiceByTransportationId = async (accessToken, params) => {
  const { page, limit, transportation_id } = params;

  let object = {
    page: page ? page : 1,
    limit: limit ? limit : 10,
    transportation_id: transportation_id ? transportation_id : undefined,
  };
  try {
    const domain = `originpackageservice/origintransportations`;
    return await clientService.getApi(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const getOriginPackageContainer = async (accessToken, params) => {
  const { page, limit, values } = params;
  let object = {
    page: page ? page : 0,
    limit: limit ? limit : 10,
    reference: values ? values.reference : undefined,
    tracking: values ? values.tracking : undefined,
    package_status: values ? values.package_status : undefined,
    route: values ? values.route : undefined,
    origin: values ? values.origin : undefined,
    destination: values ? values.destination : undefined,
    customer: values ? values.customer : "All",
    package_description: values ? values.package_description : undefined,
  };

  object.start_date = values?.start_date ? values.start_date : undefined;
  object.end_date = values?.end_date ? values.end_date : undefined;
  try {
    const domain = `originpackage/container`;
    return await clientService.getApi(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};
